export default __webpack_public_path__ + "static/gla_thumb-4170f0e1f354e23542640a0eeb4368ce.png";